import { Injectable, inject } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, map, switchMap, timeout } from "rxjs/operators";
import { HttpService } from "src/app/utils/services";
import { ConnectedReader, FingerprintDevice, FingerprintDeviceError, base64ToBytes } from "./fingerprint-device";

/** Mantra readers (MFS500, MARC10, ...) through the MorFin Auth service. */
@Injectable({ providedIn: "root" })
export class MantraDevice implements FingerprintDevice {
  readonly id = "MANTRA";
  readonly label = "Mantra";
  private readonly http = inject(HttpService);

  connect(): Observable<ConnectedReader> {
    return this.http.MorFinAuthClient("connecteddevicelist", "", false).pipe(
      timeout(5000),
      catchError(() => throwError(() => this.unavailable("not-found"))),
      map((data) => {
        if (!(data && data.ErrorCode == 0 && data.ErrorDescription)) {
          throw this.unavailable("not-found");
        }
        // e.g. "Connected Device :MFS500,..." -> "MFS500"
        return data.ErrorDescription.split(":")[1].split(",")[0];
      }),
      switchMap((model: string) =>
        this.http.MorFinAuthClient("info", { ConnectedDvc: model }, true).pipe(
          catchError(() => throwError(() => this.unavailable())),
          map((data) => {
            if (data.ErrorCode != 0) {
              throw this.unavailable();
            }
            return { device: this, model };
          })
        )
      )
    );
  }

  capture(): Observable<number[]> {
    return this.http.MorFinAuthClient("capture", { Quality: 70, TimeOut: 10 }, true).pipe(
      catchError(() => throwError(() => this.unavailable())),
      map((result) => {
        if (result.ErrorCode == 0) {
          return base64ToBytes(result.BitmapData);
        }
        throw new FingerprintDeviceError("capture", result.ErrorDescription, result.ErrorCode);
      })
    );
  }

  private unavailable(kind: "not-found" | "unavailable" = "unavailable") {
    return new FingerprintDeviceError(
      kind,
      `Check if the Mantra MorFin service is running (${this.http.sdkUrl})`
    );
  }
}
